import type { BrandRole } from '@eva/schemas';

/** O que a casca precisa saber da conta. Nada clínico, nada administrativo. */
export interface SessionUser {
  id: string;
  email: string;
  fullName: string;
  preferredName?: string | null;
  avatarUrl?: string | null;
  /** Papel legado do documento. Informativo: o que vale é o contexto. */
  role?: string;
  forcePasswordChange?: boolean;
  medicalProviderId?: string | null;
  partnerId?: string | null;
}

/** Um vínculo que a conta pode assumir — resposta de `GET /api/auth/contexts`. */
export interface AvailableContext {
  /** `null` no contexto de mantenedora — ela não mora em marca nenhuma (A044). */
  brandId: string | null;
  role: BrandRole;
  companyId: string | null;
  medicalProviderId: string | null;
  brandName?: string;
  companyName?: string;
  derived?: boolean;
  /** Vínculo aguardando aprovação da marca (A037): entra, mas não atende. */
  pendente?: boolean;
}

/** O contexto assumido — resposta de `POST /api/auth/switch-context`. */
export interface SessionContext {
  /** `null` na sessão de mantenedora (A044). */
  brandId: string | null;
  role: BrandRole;
  companyId?: string | null;
  medicalProviderId?: string | null;
  brandName?: string;
  /** Vínculo aguardando aprovação da marca (A037). */
  pendente?: boolean;
}

export interface AuthTokens {
  accessToken: string;
  refreshToken: string;
}

/** Chave estável de um contexto: é o que se lembra e o que se compara. */
export function contextKey(ctx: Pick<AvailableContext, 'brandId' | 'role' | 'companyId'>): string {
  return `${ctx.brandId ?? '*'}:${ctx.role}:${ctx.companyId ?? ''}`;
}
